var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30pt",
    height: "30pt",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 49,
    y1: 92.6667,
    x2: 49,
    y2: 13.1396,
    gradientTransform: "matrix(0.306122,0,0,-0.306122,0,31.22449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,93.72549%,81.960784%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0%,67.45098%,91.764706%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 49,
    y1: 92.6667,
    x2: 49,
    y2: 13.1396,
    gradientTransform: "matrix(0.306122,0,0,-0.306122,0,31.22449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,93.72549%,81.960784%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0%,67.45098%,91.764706%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 27.246094 8.265625 L 21.796875 8.265625 L 20.601562 5.171875 C 20.480469 4.804688 20.113281 4.59375 19.746094 4.59375 L 10.253906 4.59375 C 9.886719 4.59375 9.519531 4.835938 9.398438 5.171875 L 8.203125 8.265625 L 2.753906 8.265625 C 1.898438 8.265625 1.222656 8.9375 1.222656 9.796875 L 1.222656 25.101562 C 1.222656 25.960938 1.898438 26.632812 2.753906 26.632812 L 27.246094 26.632812 C 28.101562 26.632812 28.777344 25.960938 28.777344 25.101562 L 28.777344 9.796875 C 28.777344 8.9375 28.101562 8.265625 27.246094 8.265625 Z M 26.9375 24.796875 L 3.0625 24.796875 L 3.0625 10.101562 L 8.847656 10.101562 C 9.214844 10.101562 9.582031 9.855469 9.703125 9.519531 L 10.898438 6.429688 L 19.132812 6.429688 L 20.328125 9.519531 C 20.449219 9.886719 20.816406 10.101562 21.183594 10.101562 L 26.9375 10.101562 Z M 26.9375 24.796875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 15 10.253906 C 11.449219 10.253906 8.539062 13.164062 8.539062 16.714844 C 8.539062 20.265625 11.449219 23.171875 15 23.171875 C 18.550781 23.171875 21.460938 20.265625 21.460938 16.714844 C 21.460938 13.164062 18.550781 10.253906 15 10.253906 Z M 15 21.335938 C 12.460938 21.335938 10.378906 19.253906 10.378906 16.714844 C 10.378906 14.171875 12.460938 12.09375 15 12.09375 C 17.539062 12.09375 19.621094 14.171875 19.621094 16.714844 C 19.621094 19.253906 17.539062 21.335938 15 21.335938 Z M 15 21.335938 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default __webpack_public_path__ + "static/media/avatar-icon.a0828af9c0962d6c484ca6ccbdc5e4a2.svg";
export { ForwardRef as ReactComponent };